export default {
  backButton: 'All activities',
};
